import React from 'react';

//@ts-ignore
export default React.createContext<{
  settings: IEditorSettings;
  setSettings: React.Dispatch<React.SetStateAction<IEditorSettings>>;
}>();
